import {SizeSelection_Size} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/size_selection.types';
import {GetProductBulkResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/service.types';
import {COLORS, ContentPopperProps} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {UspDeliveryTime} from './UspDeliveryTime';
import {UspItem} from './UspItem';
import {UspMov} from './UspMov';
import {useUspsData} from './utils/useUspsData';

export interface USPsViewProps {
  className?: string;
  selectedSize?: SizeSelection_Size;
  InfoLayoutComponent?: ContentPopperProps['LayoutComponent'];
}

export const USPsView: React.FC<
  GetProductBulkResponse['uspsSection'] & USPsViewProps
> = ({className, selectedSize, articleUsps, usps, InfoLayoutComponent}) => {
  const uspsData = useUspsData({articleUsps, usps, selectedSize});

  if (!uspsData.length) {
    return null;
  }

  return (
    <VerticalList data-testid="uspList" className={className}>
      {uspsData.map((usp, index) => {
        switch (usp.type?.$case) {
          case 'standard': {
            return (
              <UspItem
                key={index}
                image={usp.type.standard.image}
                text={usp.type.standard.label}
                href={usp.type.standard.targetUrl?.url}
              />
            );
          }
          case 'movSection': {
            return (
              <UspMov
                key={index}
                movSection={usp.type.movSection}
                selectedSize={selectedSize}
              />
            );
          }
          case 'deliveryEstimationSection': {
            return (
              <UspDeliveryTime
                key={index}
                deliverySection={usp.type.deliveryEstimationSection}
                InfoLayoutComponent={InfoLayoutComponent}
              />
            );
          }
          default:
            return null;
        }
      })}
    </VerticalList>
  );
};

const VerticalList = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  border: 1px solid ${COLORS.Grey3};
`;
